import { Pipe, PipeTransform } from '@angular/core';
import {Collaborator} from '@feature-module/user/model/collaborator';

@Pipe({
  name: 'collaboratorFormatter'
})
export class CollaboratorFormatterPipe implements PipeTransform {

  transform(value: Collaborator, ...args: any[]): unknown {
    if (!value) {
      return 'Collaboratore non impostato'
    }

    const name = value.name;
    const surname = value.surname;
    return (name != null ? name : '') + ' ' + (surname != null ? surname : '');
  }

}
